import { Circle, Whatshot } from '@mui/icons-material';
import {
  type TrendingListItemResponse,
  type TrendingListItemResponseTrendingListResponseRelatedPagedData,
  TrendingListItemType,
} from '@on3/api';
import { Brands } from '@on3/ui-lib/components/Brands';
import { webUrl } from '@on3/ui-lib/utils/api';

import styles from './TopHeadlines.module.scss';

const Label = ({ type }: { type: string }) => {
  switch (type) {
    case TrendingListItemType.Trending:
      return (
        <span className={styles.tag} data-type="trending">
          Trending
        </span>
      );
    case TrendingListItemType.New:
      return (
        <span className={styles.tag} data-type="new">
          New
        </span>
      );
    case TrendingListItemType.Hot:
      return (
        <span className={styles.tag} data-type="hot">
          <Whatshot />
          Hot
        </span>
      );
    case TrendingListItemType.Live:
      return (
        <span className={styles.tag} data-type="live">
          <Circle />
          Live
        </span>
      );
    case TrendingListItemType.Breaking:
      return (
        <span className={styles.tag} data-type="breaking">
          Breaking
        </span>
      );
    case TrendingListItemType.BetMGM:
      return (
        <span className={styles.tag} data-type="betmgm">
          <img
            alt="BetMGM Logo"
            src="https://on3static.com/static/on3/mgm-branding.svg"
          />
        </span>
      );
    default:
      return null;
  }
};

export const TopHeadlines = ({
  data,
  viewAllUrl,
}: {
  data: TrendingListItemResponseTrendingListResponseRelatedPagedData;
  viewAllUrl: string;
}) => {
  const { list = [], relatedModel } = data;

  return (
    <section
      aria-labelledby="top-headlines"
      className={styles.block}
      role="complementary"
    >
      <h2 className={styles.title} id="top-headlines">
        {data.relatedModel?.displayName ?? data.relatedModel?.name ?? 'Top 10'}
        <div className={styles.logos}>
          <Brands variant="small" />
        </div>
      </h2>
      <ol aria-live="polite" className={styles.list}>
        {list.map((item: TrendingListItemResponse, index) => (
          <li key={item.key}>
            <a
              className={styles.listItem}
              href={item.url ?? ''}
              target="_parent"
              title={item.headline ?? ''}
            >
              <span className={styles.index}>{index + 1}</span>
              <div className={styles.content}>
                <div>
                  <h3>{item.subject}</h3>
                  <p>{item.headline}</p>
                </div>
                <Label type={item.type ?? ''} />
              </div>
            </a>
          </li>
        ))}
      </ol>
      {viewAllUrl && (
        <a
          className={styles.viewAll}
          href={webUrl + viewAllUrl}
          target="_parent"
          title="On3"
        >
          View All
        </a>
      )}
    </section>
  );
};
